import axios from "axios";
import authHeader from "./AuthHeader";

const API_URL = process.env.VUE_APP_MS_MAXIMO;


class QuoteService {
  
  loadQuotesToValidate(customer) {
    return axios.get(`${API_URL}/secure/quotes/sent?customer=${customer}`, {
      headers: authHeader(),
    });
  }

  loadValidatedQuotes(customer) {
    return axios.get(`${API_URL}/secure/quotes/validated?customer=${customer}`, {
      headers: authHeader(),
    });
  }

  loadRejectedQuotes(customer) {
    return axios.get(`${API_URL}/secure/quotes/rejected?customer=${customer}`, {
      headers: authHeader(),
    });
  }

  validateQuote(quote) {
    return axios.post(`${API_URL}/secure/quotes/validate`, quote, {
      headers: authHeader(),
    });
  }

  rejectQuote(worklogId, reason) {
    return axios.post((`${API_URL}/secure/quotes/reject?worklogId=${worklogId}&reason=${reason}`), {
      headers: authHeader(),
    });
  }

}

export default new QuoteService();
